import React, { useState } from 'react';
import Axios from 'axios';
import moment from 'moment'

const analytics = () => {
    const [site, setSite] = useState('')
    const [resultReady, setResultReady] = useState(false)
    const [data, setData] = useState('')
    const [loading, setLoading] = useState(false)
    const [ifError, setIfError] = useState(false)
    const [errorMessage, setErrorMssg] = useState('')

  

    const check = () => {
        
        if(!site.includes('simdan-url.herokuapp.com')){
            return alert('Invalid url provided')
        }

        if(site.substring(0,4) !== 'http'){
            return setSite('http://' + site)
        }
        
        handleSubmit()
        
        
    }
    const handleSubmit = () => {
        setLoading(true)
        setIfError('')
        Axios.get(site+'/analytics')
        .then(res => {
            console.log(res.data)
            setData(res.data)
            setLoading(false)
            setResultReady(true)
        })
        .catch(e => {

            if(!e.response){
                return
            }
            if(e.response.status === 404){
                setErrorMssg('Link not found, please check link and try again')
            } else {
                setErrorMssg(e.message)
            }
            
            setIfError(true)
            setLoading(false)
        })
        
    }

    const handleChange = (e) => {
        setSite(e.target.value)
    }

    if(ifError){
        return (
            <div>
            <div class="row">
                <form class="col s12">
                <div class="row">
                    <div class="input-field col s12">
                    {/* <label for="textarea1">Enter shortened url</label> */}
                    <textarea value={site} onChange={handleChange} id="textarea1" class="materialize-textarea" placeholder='Enter shortened url (e.g http://simdan-url.herokuapp.com/pK_2GNXID)' ></textarea>
                    </div>
                </div>
                </form>
                </div>
                <button
                className="btn waves-effect waves-light submit-btn"
                name="action"
                onClick={check}
                >
                Submit
                </button>
            <div className='errorbox' >
                <p>{errorMessage}</p>
            </div>
            </div>
        )
    }
    if(loading){
        return (
            <div>
                <div class="row">
                <form class="col s12">
                <div class="row">
                    <div class="input-field col s12">
                    {/* <label for="textarea1">Enter shortened url</label> */}
                    <textarea value={site} onChange={handleChange} id="textarea1" class="materialize-textarea" placeholder='Enter shortened url (e.g http://simdan-url.herokuapp.com/pK_2GNXID) ' ></textarea>
                    </div>
                </div>
                </form>
                </div>
                <button
                className="btn waves-effect waves-light submit-btn"
                name="action"
                onClick={check}
                >
                Submit
                </button>
                <div class="loader">Loading...</div>

            </div>
        )
    }
    return (
        <div>
        <div>
            <div class="row">
                <form class="col s12">
                <div class="row">
                    <div class="input-field col s12">
                    {/* <label for="textarea1">Enter shortened url</label> */}
                    <textarea value={site} onChange={handleChange} id="textarea1" class="materialize-textarea" placeholder='Enter shortened url (e.g http://simdan-url.herokuapp.com/pK_2GNXID) ' ></textarea>
                    </div>
                </div>
                </form>
            </div>
        </div>

        <button
        className="btn waves-effect waves-light submit-btn"
        name="action"
        onClick={check}
        >
        Submit
        </button>


        <div>
            {resultReady ? 
            <div className='resultcard' >
                <p className='visit'><span className='resultname visitvalue' >Visits: </span>{data.visit}</p>
                <p className='visit'><span className='resultname  originalurl'>Original URL: </span>{data.originalUrl}</p>
                <p className='visit'><span className='resultname  shorturl'>Short URL: </span>{data.shortUrl}</p>
                <p className='visit'><span className='resultname' >Date created: </span>{moment(data.createdAt).format('MMMM Do YYYY, h:mm:ss a') + '.   [' + moment(data.createdAt).startOf('day').fromNow() + ']' }</p>
                <p className='visit'><span className='resultname' >Last visit: </span>{moment(data.updatedAt).format('MMMM Do YYYY, h:mm:ss a')}</p>
            </div> : null}
        </div>
        </div>
    )
}

export default analytics;


// WEBPACK FOOTER //
// ./src/components/Analytics/analytics.js